import React, { Component } from 'react';
import { useRefJs } from 'core/api/useRefJs.js';
useRefJs.setConfig({ 'business_component/billTrack/billTrack/main/index': '../../../../business_component/billTrack/billTrack/main/index.js' });

let BillTrack = useRefJs(["business_component/billTrack/billTrack/main/index"], function (Poc) {
    class BillTrack extends Component {
        constructor(props) {
            super(props);
        }
        render() {
            const { forwardedRef, ...rest } = this.props;
            return <Poc ref={forwardedRef} {...rest} />;
        }
    }
    return React.forwardRef((props, ref) => {  
        return <BillTrack {...props} forwardedRef={ref} />;  
    });
});

export default BillTrack;
